<template>
<div class="main">

  <div class="ut-text-center container">

    <div class="placeholder ut-mt-12 ut-mb-8">
      <img class="ut-m-auto ut-block" src="@/assets/images/verify_request.svg">
    </div>
    <h1 class="ut-font-semibold ut-text-xl ut-mb-8">Your request for an appraisal&nbsp;is&nbsp;being&nbsp;verified</h1>

    <p>Our team is just checking that we have everything needed for an agent to give you an accurate appraisal. We'll forward your request to them&nbsp;shortly.</p>

    <p class="foottext ut-mt-8">At any time you can see where your request is at, contact the agent directly, or leave feedback in your OpenAgent&nbsp;Portal</p>

    <div @click="openMyOA()" class="ut-oa-btn ut-mt-8">My OpenAgent</div>

  </div>

</div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'RequestAppraisalThanks',
  params: {
  },
  components: {
  },

  data() {
    return {
      errors: [],
    };
  },
  methods: {
    openMyOA() {
      window.open(`${process.env.VUE_APP_MYOA}/?ik=${this.$route.params.interactionKey}`, '_blank');
    }
  },

  created() {},
};
</script>

<style scoped lang="scss">
.container {
    max-width: 600px;
    margin: 0 auto;
    padding: 0 25px;
}
</style>
